import { useOne } from '@refinedev/core';
import { useMemo } from 'react';

type LastReviewDateResponse = {
  lastReviewDate?: string;
};

export const useLastReviewDate = (clientId?: string) => {
  const { data, isLoading, isError, refetch } = useOne<LastReviewDateResponse>({
    resource: `clients/${clientId}/suitability-reports/last-review-date`,
    id: '',
    queryOptions: {
      enabled: !!clientId,
    },
  });

  const lastReviewDate = useMemo(() => {
    return data?.data?.lastReviewDate ? new Date(data.data.lastReviewDate) : undefined;
  }, [data?.data?.lastReviewDate]);

  return {
    lastReviewDate,
    isLoading,
    isError,
    refetch,
  };
};
